import { ChevronRight } from "lucide-react";
import { Link } from "react-router";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const SITE_ORIGIN = "https://turaq.kg";

function breadcrumbJsonLd(items: BreadcrumbItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: item.to ? `${SITE_ORIGIN}${item.to}` : undefined,
    })),
  };
}

export const Breadcrumb = ({ items }: BreadcrumbProps) => (
  <>
    <script type="application/ld+json">
      {JSON.stringify(breadcrumbJsonLd(items))}
    </script>
    <nav
      aria-label="Breadcrumb"
      className="flex min-w-0 items-center gap-1.5 text-xs text-gray-400 mb-4"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          // Earlier crumbs keep their width; a long last one shortens with "…".
          <span key={item.label} className={`flex items-center gap-1.5 ${isLast ? "min-w-0" : "shrink-0"}`}>
            {index > 0 && <ChevronRight size={12} className="shrink-0" />}
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="hover:text-blue-600 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "truncate text-gray-600 font-medium" : ""}>
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  </>
);
